module.exports = __webpack_public_path__ + "img/1.ecc3c2e2.jpg";